module.exports = __webpack_public_path__ + "img/oval-blue.9e00a055.svg";